/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-24 09:20:12
 * @LastEditors: caiqin.xie
 * @message: 维修价格-Notes组件
 */
import React from "react";
import styles from "../../index.module.scss";
import classNames from "classnames";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  notes: string; // notes内容
}

const Notes = (props:IProps) => {
  const {ctry, words, notes} = props

  // 渲染html
  const creatHtml = () => {
    return {__html: notes}
  }

  return (
    <>
      {notes && notes !== '' && (
        <div className={styles['remind-wrap']}>
          <h2 className={styles['remid-title']}>
            {words?.support_maintenance_price_notes}
            {/* Notes */}
          </h2>
          <div className={classNames(styles['remid-list'], 'editor-wrap')}  dangerouslySetInnerHTML={creatHtml()}></div>
        </div>
      )}
    </>
  )
}
export default Notes